export default __webpack_public_path__ + "static/azul-8c82d8fadf180f493a019a39c8142df6.jpg";